import { defineMessage } from 'react-intl';

export const fallbackPrudsysHeadline = defineMessage({
  defaultMessage: 'Andere Kunden interessierte auch',
  id: 'rde.prudsys.headline-fallback',
});
